import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9bdde074"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex flex-row items-center"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = {
  key: 0,
  class: "exportButton cursor-pointer"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "exportButton cursor-pointer" }

import { generateExcel } from "@/api/generate-excel-api";
import { useStore } from "@/composables/useTypedStore";
import useUser from "@/composables/useUser";
import BestandsaufnahmeModel from "@/models/ba/models/bestandsaufnahme.model";
import { SelectModeState } from "@/types/app/survey-types";
import { Monitoring } from "@/utilities/monitoring";
import { IonButton, IonContent, IonIcon, IonItem, IonList, IonPopover, IonSpinner } from "@ionic/vue";
import { Canceler } from "axios";
import { caretForwardOutline, closeCircleOutline, downloadOutline } from "ionicons/icons";
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'ExportButtons',
  props: {
    showAsStartButton: { type: Boolean, default: false }
  },
  emits: ["export-geojson"],
  setup(__props: any, { emit }) {





const isExporting = ref(false);
const abortExportFunction = ref<Canceler | null>(null);
const isPopoverOpen = ref(false);
const popoverElement = ref<InstanceType<typeof IonPopover> | null>(null);


const { user } = useUser();
const store = useStore();
const { t, locale } = useI18n({ useScope: "global" });

const isSelectionEmpty = computed(() => {
  if (store.state.entities.selectModeSurveyCards === SelectModeState.ALL) {
    return store.state.entities.bestandsaufnahmes.totalSearchResultsCount === 0;
  } else {
    return store.state.entities.bestandsaufnahmes.selectedSurveyCards.size === 0;
  }
});


const featureFlags = computed(() => user.value?.organisation?.featureFlags);
const currentProject = computed(() => store.state.user.currentUserProject);
const organisationPrefix = computed(() => store.getters["user/organisationPrefix"]);

const isGeoExportEnabled = computed(() => {
  return !!featureFlags.value?.survey?.exportgeojson;
});

const isExcelExportEnabled = computed(() => {
  return !!featureFlags.value?.survey?.exportxls;
});

const onlyOneExportType = computed(() => {
  return isGeoExportEnabled.value !== isExcelExportEnabled.value;
});

const title = computed(() => {
  if (onlyOneExportType.value) {
    return isGeoExportEnabled.value ? "Export GeoJSON" : "Export Excel";
  }
  return t("hzba.export.exportData");
});

const closePopover = () => {
  isPopoverOpen.value = false;
  popoverElement.value?.$el.dismiss(); // make sure to close the popover
};


const exportGeojson = () => {
  isExporting.value = true;
  closePopover();
  BestandsaufnahmeModel.dispatch("downloadGeodataForListOfSurveys")
    .finally(() => {
      isExporting.value = false;
    });
};

// TODO: move excel export logic to store similar to geojson export
const exportExcel = () => {
  if (user?.value?.organisation?.id && currentProject?.value?.id) {
    closePopover();
    isExporting.value = true;
    const { call, abort } = generateExcel(
      user.value.organisation.id,
      currentProject.value.id,
      t(`${organisationPrefix.value}hzba.bestandsaufnahmen`),
      locale.value
    );

    call.finally(() => {
      isExporting.value = false;
    });

    abortExportFunction.value = abort;
  } else {
    Monitoring.withScope((scope) => {
      scope.setContext("export info", { projectId: currentProject?.value?.id, organisationId: user?.value?.organisation?.id });
      Monitoring.error("Cannot export excel-sheet, no organisation or project id found for user");
    });
  }
};

const emitExportGeojson = () => {
  emit("export-geojson");
  closePopover();
};

const onExport = () => {
  if (isGeoExportEnabled.value) {
    emitExportGeojson();
  } else if (isExcelExportEnabled.value) {
    exportExcel();
  }
};

const abortExport = () => {
  if (abortExportFunction.value) {
    abortExportFunction.value();
  }
  BestandsaufnahmeModel.dispatch("abortExport");
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isExporting.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_unref(IonButton), {
            title: _ctx.$t('hzba.export.abortExport'),
            onClick: _withModifiers(abortExport, ["stop"])
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonIcon), {
                slot: "icon-only",
                icon: _unref(closeCircleOutline),
                class: "w-6 h-6"
              }, null, 8, ["icon"])
            ]),
            _: 1
          }, 8, ["title", "onClick"]),
          _createVNode(_unref(IonSpinner), {
            name: "circular",
            class: "ml-4"
          })
        ]))
      : (_ctx.showAsStartButton)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_unref(IonButton), {
              title: "GeoJSON Export",
              disabled: isSelectionEmpty.value,
              onClick: _withModifiers(exportGeojson, ["stop"])
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonIcon), {
                  slot: "start",
                  icon: _unref(caretForwardOutline),
                  class: "w-6 h-6"
                }, null, 8, ["icon"]),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('hzba.export.startExport')), 1)
              ]),
              _: 1
            }, 8, ["disabled", "onClick"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (onlyOneExportType.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_unref(IonButton), {
                    title: title.value,
                    onClick: _withModifiers(onExport, ["stop"])
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), {
                        slot: "icon-only",
                        icon: _unref(downloadOutline),
                        class: "w-6 h-6"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["title", "onClick"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_unref(IonButton), {
                      id: "ms-export-button-popover-trigger",
                      title: title.value,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (isPopoverOpen.value = true))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonIcon), {
                          slot: "icon-only",
                          icon: _unref(downloadOutline),
                          class: "w-6 h-6"
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }, 8, ["title"])
                  ])
                ]))
          ])),
    _createVNode(_unref(IonPopover), {
      ref_key: "popoverElement",
      ref: popoverElement,
      trigger: "ms-export-button-popover-trigger",
      "is-open": isPopoverOpen.value,
      onDidDismiss: _cache[1] || (_cache[1] = ($event: any) => (isPopoverOpen.value = false))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonContent), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonList), { class: "p-0" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonItem), {
                  button: true,
                  detail: false,
                  onClick: _withModifiers(exportExcel, ["stop"])
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Excel ")
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_unref(IonItem), {
                  button: true,
                  detail: false,
                  onClick: _withModifiers(emitExportGeojson, ["stop"])
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" GeoJSON ")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["is-open"])
  ], 64))
}
}

})